@if (gotDgProperties) {
  <div class="row">
    <div class="col-12">
      <form [formGroup]="filterForm" class="tablelist-form" autocomplete="off">
        <div class="d-flex justify-content-end align-items-end">
    
          <div class="me-3">
            <div class="mb-3 d-flex align-items-center" style="height: 38px;">
              <label class="form-check-label mb-0 me-2" for="allRecords-field">Return all Rows</label>
              <div class="form-check form-switch mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="allRecords-field"
                  formControlName="allRecords"
                  style="transform: scale(1.3);"
                  (click)="showAllRecordsClick()"
                />
              </div>
            </div>
          </div>
    
          <div class="me-3">
            <div class="mb-3">
              <label for="selecttop-field" class="form-label">Select Top [<em>n</em>]</label>
              <input
                class="form-control text-end"
                data-lpignore="true"
                id="selecttop-field"
                inputmode="numeric"
                formControlName="selecttop"
                pattern="[0-9]*"
                style="max-width: 100px;"
                type="text"
                (input)="validateNumericInput()"
              />
              <div *ngIf="formOfFilterForm['selecttop']?.hasError('greaterThanZero') && (formOfFilterForm['selecttop']?.touched || formOfFilterForm['selecttop']?.dirty)" class="invalid-feedback d-block">
                Value greater than 0 required.
              </div>
              <div *ngIf="formOfFilterForm['selecttop']?.hasError('required') && (formOfFilterForm['selecttop']?.touched || formOfFilterForm['selecttop']?.dirty)" class="invalid-feedback d-block">
                Value is required.
              </div>
            </div>
          </div>
    
          <div class="me-3">
            <div class="mb-3">
              <app-dropdown-date
                [initialDate]="startDate"
                title="Start Date"
                (selectOnChangeEvent)="startDateChanged($event)"
              ></app-dropdown-date>
            </div>
          </div>
    
          <div class="mb-3">
            <app-dropdown-date
              [initialDate]="endDate"
              title="End Date"
              (selectOnChangeEvent)="endDateChanged($event)"
            ></app-dropdown-date>
          </div>
    
        </div>
      </form>
    </div>
  </div>

  <app-grid-view #gridView
    [apiPath]="dgApiPath"
    [dgActionColumn]="dgActionColumn"
    [dgColumns]="dgColumns"
    [dgPopup]="dgPopup"
    [dgProperties]="dgProperties"
    (addButtonClick)="gridAddButtonClick($event)"
    (editButtonClick)="gridEditButtonClick($event)"
  >
  </app-grid-view>
}
